import React, { useContext, useState } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import logIcon from "../../assets/icons/avatar_icon.svg";
import BrandLogo from "../../molecules/BrandLogo";
import PinkButton from "../../molecules/PinkButton";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../../contex/AuthProvider";
import ScrollTop from "../../molecules/ScrollTop";

const pages = [
  { title: "how it works", path: "/" },
  { title: "start a project", path: "/project" },
  { title: "faq", path: "/" },
];

const Navigation = () => {
  const { user, signout } = useContext(AuthContext);
  console.log("🚀 ~ Navigation ~ user", user);
  const navigate = useNavigate();
  const location = useLocation();
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [settings, setSettings] = useState();
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };
  React.useEffect(() => {
    handleCloseUserMenu();
    user.login ? setSettings(["log out"]) : setSettings(["login", "register"]);
  }, [location.pathname]);

  const handleCloseNavMenu = (title) => {
    setAnchorElNav(null);
    title !== "log out" ? navigate("/auth") : signout(setAnchorElNav(null));
    title === "log out" && setSettings(["login", "register"]);
  };

  const handleCloseMenu = (path) => {
    path && navigate(path);
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };
  return (
    <div className="">
      <ScrollTop />
      <AppBar
        position="static"
        color="inherit"
        sx={{
          boxShadow: 0,
          color: "grey",
          borderBottom: "4px solid #800080",
        }}
        className="px-2 md:px-20"
      >
        <Container maxWidth="xl">
          <Toolbar disableGutters>
            <Typography
              variant="h6"
              noWrap
              className=""
              component="div"
              sx={{ mr: 2, display: { xs: "none", md: "flex" } }}
            >
              <Link to="/">
                <BrandLogo />
              </Link>
            </Typography>

            {/* For Mobile devices */}
            <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                color="inherit"
              >
                <MenuIcon />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseMenu}
                sx={{
                  display: { xs: "block", md: "none" },
                }}
              >
                <MenuItem >
                  <Link to="/" onClick={handleCloseMenu}>
                    <Typography
                      variant="p"
                      noWrap
                      className=""
                      component="div"
                      sx={{ mr: 2 }}
                    >
                      <BrandLogo imgClass="h-6" className="py-2" />
                    </Typography>
                  </Link>
                </MenuItem>
                {pages.map((page) => (
                  <MenuItem
                    key={page.title}
                    onClick={() => handleCloseMenu(page.path)}
                  >
                    <Typography textAlign="center">{page.title}</Typography>
                  </MenuItem>
                ))}
              </Menu>
            </Box>
            {location.pathname !== "/auth" && (
              <>
                {/* ============ 0 ============ */}
                {/* <Typography
                  variant="h6"
                  noWrap
                  component="div"
                  sx={{ flexGrow: 1, display: { xs: "none", md: "none" } }}
                >
                  <BrandLogo />
                </Typography> */}
                <Box
                  sx={{ flexGrow: 2, display: { xs: "none", md: "flex" } }}
                ></Box>
                {location.pathname === "/" && (
                  <Box
                    sx={{
                      flexGrow: 0,
                      marginRight: 2,
                      display: { xs: "none", md: "flex" },
                    }}
                  >
                    {pages.map((page) => (
                      <Typography
                        key={page.title}
                        onClick={() => navigate(page.path)}
                        sx={{
                          my: 2,
                          color: "#999999",
                          display: "block",
                          mr: 6,
                          cursor: "pointer",
                        }}
                      >
                        {page.title}
                      </Typography>
                    ))}
                  </Box>
                )}
                <Box sx={{ flexGrow: 0 }}>
                  <Tooltip title="profile settings">
                    <span onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                      {user.login ? (
                        <Avatar
                          sx={{
                            bgcolor: "#800080",
                            fontWeight: 700,
                            fontSize: "18px",
                          }}
                        >
                          {user?.name ? user?.name.slice(0, 2) : "XY"}
                        </Avatar>
                      ) : (
                        <PinkButton icon={logIcon} />
                      )}
                    </span>
                  </Tooltip>
                  <Menu
                    sx={{ mt: "55px" }}
                    id="menu-appbar"
                    anchorEl={anchorElUser}
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    keepMounted
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    open={Boolean(anchorElUser)}
                    onClose={handleCloseUserMenu}
                  >
                    {settings?.map((setting, i) => (
                      <MenuItem
                        key={setting}
                        onClick={() => handleCloseNavMenu(setting)}
                        sx={{ width: "160px" }}
                      >
                        <Typography
                          sx={
                            i === settings.length - 1
                              ? {
                                  borderBottom: "none",
                                  width: "100%",
                                  color: "#999999",
                                }
                              : {
                                  paddingBottom: "8px",
                                  borderBottom: "1px solid #999999",
                                  width: "100%",
                                  color: "#999999",
                                }
                          }
                          textAlign="start"
                        >
                          {setting}
                        </Typography>
                      </MenuItem>
                    ))}
                  </Menu>
                </Box>
              </>
            )}
          </Toolbar>
        </Container>
      </AppBar>
    </div>
  );
};

export default Navigation;
